export default __webpack_public_path__ + "static/media/subscriptions.1502e288.svg";